var path = '/modules/media/views/index.tpl.html';
var html = "<section>\n    <h1>{{'media.pages.index.headline'|translate}}</h1>\n    <div class=\"content-box\">\n        <div class=\"mt-20\">\n            <al-media-manager\n                    current-directory=\"null\"\n                    enable-file-selection=\"false\"\n                    on-file-selection=\"vm.handleFileSelection(file)\"></al-media-manager>\n        </div>\n    </div>\n</section>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/media/views/index.tpl.html
// module id = 2136
// module chunks = 1